import { AbstractRepository, ApiPagination, ApiParameters } from '@/repositories/abstract-repository';
import { Change, Update, UpdateSortParameter } from '@/families/models/update';
import { CrmApiResponse } from '@/models/base';

export interface UpdatesParams {
    filter_comments?: boolean;
    full_audit?: boolean;
    search?: string;
    since?: number;
    ignore_center_ids_filter?: string | boolean;
    recent?: number;
}

export class UpdatesRepository extends AbstractRepository<Update> {
    readonly endpoint = 'updates';

    async getAllUpdatesForFamily(
        familyId: number,
        pagination: ApiPagination,
        sort?: UpdateSortParameter,
        filterComments = false,
        isFullAudit = true,
        search = '',
        abortController: AbortController | null = null
    ): Promise<CrmApiResponse<Change>> {
        const updatesParams: UpdatesParams = {
            since: 1,
            ignore_center_ids_filter: 'true',
            filter_comments: filterComments,
            recent: 1,
            full_audit: isFullAudit
        };

        if (search) {
            updatesParams.search = search;
        }

        const params: ApiParameters = {
            ...updatesParams,
            limit: pagination.limit,
            offset: pagination.offset
        };

        if (sort) {
            params.sort_keys = sort.sort_keys;
            params.sort_dir = sort.sort_dir;
        }

        const response = await this.client.get('families/' + familyId + '/updates', {
            params,
            signal: abortController?.signal
        });

        const count = parseInt(response.headers['x-total-count']);
        return {
            entities: response.data,
            count: !isNaN(count) ? count : 0
        };
    }

    async updatesByStaff(timestamp: number, staff_id: number, center_ids: Array<number>): Promise<Array<Update>> {
        const response = await this.client.get<Array<Update>>(this.endpoint, {
            params: {
                since: timestamp,
                updated_by_staff_id: staff_id,
                center_ids: center_ids,
                recent: 1,
                limit: 15
            }
        });
        return response.data;
    }
}
